import { Instance } from 'mobx-state-tree'
import { SubsPaymentSheetResponseModelBase } from './SubsPaymentSheetResponseModel.base'

/* The TypeScript type of an instance of SubsPaymentSheetResponseModel */
export interface SubsPaymentSheetResponseModelType extends Instance<typeof SubsPaymentSheetResponseModel.Type> {}

/* A graphql query fragment builders for SubsPaymentSheetResponseModel */
export {
  selectFromSubsPaymentSheetResponse,
  subsPaymentSheetResponseModelPrimitives,
  SubsPaymentSheetResponseModelSelector
} from './SubsPaymentSheetResponseModel.base'

/**
 * SubsPaymentSheetResponseModel
 */
export const SubsPaymentSheetResponseModel = SubsPaymentSheetResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
